export const CALENDAR_TASK_DETAILS_STORAGE_PREFIX = 'ell.calendarTaskDetails.v1'
export const CALENDAR_TASK_DETAILS_DEFAULT = true

export const calendarTaskDetailsStorageKey = (tenantId: number, userId: number): string =>
  `${CALENDAR_TASK_DETAILS_STORAGE_PREFIX}:tenant:${tenantId}:user:${userId}`

export const readCalendarTaskDetailsPreference = (
  tenantId: number | null | undefined,
  userId: number | null | undefined,
): boolean => {
  if (tenantId == null || userId == null) return CALENDAR_TASK_DETAILS_DEFAULT

  try {
    if (typeof localStorage === 'undefined') return CALENDAR_TASK_DETAILS_DEFAULT

    const storedPreference = localStorage.getItem(calendarTaskDetailsStorageKey(tenantId, userId))
    if (storedPreference == null) return CALENDAR_TASK_DETAILS_DEFAULT

    const parsedPreference: unknown = JSON.parse(storedPreference)
    return typeof parsedPreference === 'boolean' ? parsedPreference : CALENDAR_TASK_DETAILS_DEFAULT
  } catch {
    return CALENDAR_TASK_DETAILS_DEFAULT
  }
}

export const writeCalendarTaskDetailsPreference = (
  tenantId: number | null | undefined,
  userId: number | null | undefined,
  preference: boolean,
): void => {
  if (tenantId == null || userId == null) return

  try {
    if (typeof localStorage === 'undefined') return

    localStorage.setItem(
      calendarTaskDetailsStorageKey(tenantId, userId),
      JSON.stringify(preference),
    )
  } catch {
    // Persistence is best-effort when browser storage is unavailable.
  }
}
